var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup15085(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15085",
    "data-name": "Group 15085",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.505,
    height: 50.505,
    viewBox: "0 0 50.505 50.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M25.252,0A25.252,25.252,0,1,1,0,25.252,25.252,25.252,0,0,1,25.252,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15063",
    "data-name": "Group 15063",
    transform: "translate(11.773 11.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M320.987,103.776a2.357,2.357,0,1,1,3.469-3.192,18.963,18.963,0,0,0,1.631,1.571,13.632,13.632,0,0,0,4.942,2.854,3.783,3.783,0,0,0,3.736-.685,4.748,4.748,0,0,0,.4-.413c1.549-1.811,2.861-5.213,3.876-8.594,1.077-3.587,1.793-7.058,2.156-8.84a2.354,2.354,0,1,1,4.612.94c-.385,1.887-1.141,5.559-2.249,9.246-1.17,3.894-2.76,7.905-4.817,10.31a9.5,9.5,0,0,1-.786.819,8.234,8.234,0,0,1-8.164,1.772,18.368,18.368,0,0,1-6.769-3.832A23.8,23.8,0,0,1,320.987,103.776Z",
    transform: "translate(-320.364 -84.594)",
    fill: "#47c431",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M418.061,204.246A4.251,4.251,0,1,0,413.81,200,4.259,4.259,0,0,0,418.061,204.246Z",
    transform: "translate(-407.18 -187.858)",
    fill: "#47c431",
    fillRule: "evenodd",
    opacity: 0.728
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15085);
export default __webpack_public_path__ + "static/media/Group 15085.896ae74d4dd5236cac5bf6ad7cbdea16.svg";
export { ForwardRef as ReactComponent };